module.exports = __webpack_public_path__ + "25e6fc6d2e458ef9c9eec47bdee415ff.png";